export default __webpack_public_path__ + "static/media/AAE-Fire-Fx-04.d4257782.jpg";